{
  "login": {
    "title": "Sign in.",
    "subtitle": "Pick up where you left off.",
    "email_label": "Email",
    "password_label": "Password",
    "submit": "Continue",
    "loading": "Signing in…",
    "forgot_short": "Forgot?",
    "no_account": "Don't have an account?",
    "register_link": "Create one free",
    "forgot_link": "Forgot your password?",
    "network_error": "We couldn't connect. Please try again in a moment.",
    "show_password": "Show password",
    "hide_password": "Hide password",
    "errors": {
      "credentials": "We don't recognize those credentials. Double-check your email and password.",
      "rate_limit": "Too many attempts. Wait a moment and try again.",
      "generic": "Something went wrong. Try again.",
      "google": "We couldn't sign you in with Google.",
      "google_generic": "We couldn't complete sign-in with Google. Try again.",
      "apple": "We couldn't sign you in with Apple. Try again.",
      "microsoft": "We couldn't sign you in with Microsoft.",
      "microsoft_no_account": "There is no Tworks account with this email. Register first, then link Microsoft."
    }
  },
  "register": {
    "title": "Create your account.",
    "subtitle": "14 days of Pro free. No credit card.",
    "name_label": "Name",
    "email_label": "Email",
    "password_label": "Password",
    "password_confirmation_label": "Confirm password",
    "password_hint": "Minimum 8 characters",
    "submit": "Create account",
    "loading": "Creating…",
    "has_account": "Already have an account?",
    "login_link": "Sign in",
    "network_error": "We couldn't connect. Please try again in a moment.",
    "show_password": "Show password",
    "hide_password": "Hide password",
    "terms": "By signing up you accept our {terms} and {privacy}.",
    "terms_link": "Terms",
    "privacy_link": "Privacy Policy",
    "errors": {
      "generic": "We couldn't create your account.",
      "google": "We couldn't create your account with Google.",
      "google_generic": "We couldn't complete sign-in with Google. Try again.",
      "apple": "We couldn't create your account with Apple. Try again."
    },
    "strength_weak": "Weak",
    "strength_fair": "Fair",
    "strength_strong": "Strong"
  },
  "forgot": {
    "title": "Forgot your password?",
    "subtitle": "We'll send you a link to create a new one.",
    "email_label": "Email",
    "submit": "Send link",
    "loading": "Sending…",
    "success_title": "All set, check your inbox.",
    "success": "If an account exists with that email, we just sent you a link to reset it.",
    "network_error": "We couldn't connect. Please try again in a moment.",
    "back_to_login": "Back to sign in",
    "errors": {
      "rate_limit": "Too many attempts. Wait a moment."
    }
  },
  "reset": {
    "title": "New password.",
    "subtitle": "Choose one you'll remember this time.",
    "password_label": "New password",
    "password_confirmation_label": "Confirm",
    "submit": "Update password",
    "loading": "Updating…",
    "success_title": "Password updated.",
    "success_redirect": "Taking you back to sign in shortly…",
    "invalid_link_title": "Invalid or incomplete link",
    "invalid_link_message": "We need the full link from the email to continue.",
    "network_error": "We couldn't connect. Please try again in a moment.",
    "back_to_login": "Back to sign in",
    "show_password": "Show password",
    "hide_password": "Hide password",
    "errors": {
      "invalid_token": "This link expired or has already been used. Request a new one.",
      "rate_limit": "Too many attempts. Wait a moment.",
      "generic": "We couldn't reset your password."
    }
  },
  "invite_modal": {
    "title": "Invite to team",
    "email_label": "Email",
    "email_placeholder": "person{'@'}company.com",
    "email_hint": "If they don't have an account yet, we'll email them a link to create one.",
    "seat_notice": "This person takes an extra seat: ${monthly} per month or ${yearly} per year depending on your billing cycle, prorated.",
    "role_label": "Role",
    "role_member": "Member — can view and edit projects",
    "role_admin": "Admin — can manage the team",
    "role_guest": "Guest — limited access",
    "submit": "Send invitation",
    "loading": "Sending…",
    "close": "Close",
    "error_generic": "We couldn't process the invitation.",
    "error_unexpected": "Unexpected error. Please try again."
  },
  "invite": {
    "loading": "Loading invitation…",
    "brand": "Tworks",
    "go_home": "Go home",
    "sign_in": "Sign in",
    "not_available_title": "Invitation not available",
    "already_used_title": "Invitation already used",
    "already_used_message": "This invitation was previously accepted.",
    "expired_title": "Invitation expired",
    "expired_message": "This invitation has expired. Ask {inviter} to send you a new one.",
    "pending_title": "You've been invited to Tworks",
    "pending_message": "{inviter} invited you to collaborate on {team} as {role}.",
    "different_user_message": "You're signed in as {current}, but this invitation is for {email}.",
    "logout_and_accept_as": "Sign out and accept as {email}",
    "accept_as_current": "Join {team}",
    "accepting": "Accepting…",
    "register_email_label": "Email",
    "register_name_label": "Your name",
    "register_password_label": "Password",
    "register_password_confirm_label": "Confirm password",
    "register_submit": "Join {team}",
    "register_submitting": "Creating account…",
    "register_disclaimer": "By creating your account you agree to join the team.",
    "expires_on": "This invitation expires on {date}.",
    "hero_title": "Collaborate with your team without friction.",
    "hero_subtitle": "Projects, tasks, and conversations — all organized in one place, in real time.",
    "hero_badge": "Joining is free",
    "errors": {
      "not_found": "This invitation doesn't exist or has been removed.",
      "load_failed": "We couldn't load the invitation.",
      "accept_failed": "We couldn't accept the invitation.",
      "register_failed": "We couldn't complete the signup."
    }
  },
  "google": {
    "continue": "Continue with Google",
    "connecting": "Connecting...",
    "divider": "or"
  }
}
